import { Pipe, PipeTransform } from '@angular/core';

/**
 * Replace facet key
 */
@Pipe({
    name: 'replaceKey',
    standalone: true
})
export class ReplaceKeyPipe implements PipeTransform {
    transform(key: string, replacers: { [search: string]: string }): string {
        return replacers[key] ? replacers[key] : key;
    }
}
